import { Component, Input, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { BaseResultChartComponent } from '../../visual-data-components/base-result-chart-component.directive';
import { SimpleSolarCalculatorResult } from '../../../../models/analysis/simple-solar-calculator-result';
import { elEnergyChartData, elEnergyChartOptions } from '../../chart-options';
import {
  CalculatorColorConfig,
} from '../../../calculator/calculator-components/simple-calculator/calculator-color-config';

@Component({
  selector: 'psc-yearly-consumption-projection-chart',
  templateUrl: './yearly-consumption-projection-chart.component.html'
})
export class YearlyConsumptionProjectionChartComponent  extends BaseResultChartComponent<SimpleSolarCalculatorResult> implements OnInit  {
  @Input() colorConfig!: CalculatorColorConfig;
  protected elEnergyChartData = elEnergyChartData();
  protected elEnergyChartOptions = elEnergyChartOptions();
  protected readonly elEnergyChartType: ChartType = 'line';


  override ngOnInit() {
    if (this.colorConfig?.primaryColor && this.colorConfig?.secondaryColor) {
      this.elEnergyChartData = elEnergyChartData({
        colors: {
          firstDataset: {
            backgroundColor: this.colorConfig.primaryColor,
            lineAndPointColor: this.colorConfig.primaryColor,
          },
          secondDataset: {
            backgroundColor: this.colorConfig.secondaryColor,
            lineAndPointColor: this.colorConfig.secondaryColor,
          },
        },
      });
      this.elEnergyChartOptions = elEnergyChartOptions({
        legendColor: this.colorConfig.primaryColor,
        backgroundColor: this.colorConfig.primaryColor,
        lineColor: this.colorConfig.primaryColor,
        tickColor: this.colorConfig.secondaryColor,
      });
    }
    this.setChartData();
    super.ngOnInit();
    if(this.elEnergyChartOptions?.elements?.line?.tension) {
      this.elEnergyChartOptions.elements.line.tension = 0.1;
    }
    /**
     * t(calculator_result.chart.consumption_without_loan, calculator_result.chart.consumption_with_loan)
     */
    this.subscribeToLabelTranslation('consumption_without_loan', this.elEnergyChartData.datasets[0]);
    this.subscribeToLabelTranslation('consumption_with_loan', this.elEnergyChartData.datasets[1]);
  }

  protected setChartData() {
    this.elEnergyChartData.datasets[0].data = new Array(this.solarCalculatorResult.yearlyConsumptionProjection.length).fill(this.solarCalculatorResult.avgMonthlyConsumptionBeforeLoan);
    this.elEnergyChartData.datasets[1].data = this.solarCalculatorResult.yearlyConsumptionProjection;
  }
}
